import { useState } from 'react';
import { useSessao } from '../sessao.js';

export function Login({ aoCriarConta }: { aoCriarConta?: () => void }) {
  const { entrar } = useSessao();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function enviar(e: React.FormEvent) {
    e.preventDefault();
    setErro(null);
    setEnviando(true);
    try {
      await entrar(email, senha);
    } catch (erroLogin) {
      // A API devolve a mesma mensagem para e-mail inexistente e senha errada,
      // de propósito. Repetimos aqui sem tentar ser mais específicos.
      setErro(erroLogin instanceof Error ? erroLogin.message : 'Não foi possível entrar.');
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-canvas px-4">
      <form
        onSubmit={enviar}
        className="w-full max-w-[380px] rounded-[var(--radius-card)] border border-borda bg-superficie p-6 shadow-[var(--shadow-card)]"
      >
        <h1 className="text-[length:var(--text-tela)] font-semibold text-texto">True Finance</h1>
        <p className="mt-1 text-[length:var(--text-secundario)] text-texto-secundario">
          Seu financeiro pelo WhatsApp
        </p>

        <label className="mt-5 block">
          <span className="text-[length:var(--text-coluna)] font-semibold uppercase tracking-[0.05em] text-texto-terciario">
            E-mail
          </span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="email"
            // 44px de altura: alvo de toque confortável no celular.
            className="mt-1 h-11 w-full rounded-[var(--radius-controle)] border border-borda-input bg-superficie px-3 text-[length:var(--text-corpo)] text-texto"
          />
        </label>

        <label className="mt-3 block">
          <span className="text-[length:var(--text-coluna)] font-semibold uppercase tracking-[0.05em] text-texto-terciario">
            Senha
          </span>
          <input
            type="password"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            required
            autoComplete="current-password"
            className="mt-1 h-11 w-full rounded-[var(--radius-controle)] border border-borda-input bg-superficie px-3 text-[length:var(--text-corpo)] text-texto"
          />
        </label>

        {erro && (
          <p
            role="alert"
            className="mt-3 rounded-[var(--radius-controle)] bg-saida-bg px-3 py-2 text-[length:var(--text-secundario)] text-saida-fg"
          >
            {erro}
          </p>
        )}

        <button
          type="submit"
          disabled={enviando}
          className="mt-5 h-11 w-full rounded-[var(--radius-controle)] bg-primaria font-medium text-white hover:bg-primaria-hover disabled:opacity-45"
        >
          {enviando ? 'Entrando...' : 'Entrar'}
        </button>

        {aoCriarConta && (
          <button
            type="button"
            onClick={aoCriarConta}
            className="mt-3 w-full text-center text-[length:var(--text-secundario)] text-primaria hover:underline"
          >
            Criar uma conta
          </button>
        )}

        <p className="mt-4 text-center text-[length:var(--text-metadado)] text-texto-terciario">
          Acesso restrito. Autenticação em duas etapas em breve.
        </p>
      </form>
    </div>
  );
}
